var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClearRepo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9167 13.2244L42.5092 9.77778L33.8333 18.5533L25.1575 9.77778L21.75 13.2244L30.4258 22L21.75 30.7756L25.1575 34.2222L33.8333 25.4467L42.5092 34.2222L45.9167 30.7756L37.2408 22L45.9167 13.2244ZM53.1667 44C54.4485 44 55.6779 43.4849 56.5843 42.5681C57.4908 41.6512 58 40.4077 58 39.1111L58 4.88889C58 3.59227 57.4908 2.34877 56.5843 1.43192C55.6779 0.515079 54.4485 0 53.1667 0L16.9167 0C15.2492 0 13.9442 0.879997 13.0742 2.17556L0 22L13.0742 41.8489C13.9442 43.1444 15.2492 44 16.9167 44L53.1667 44ZM53.1667 39.1111L16.9167 39.1111L5.51 22L16.9167 4.88889L53.1667 4.88889L53.1667 39.1111Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearRepo);
export default __webpack_public_path__ + "static/media/clearRepo.606e1cf908c2a2b81d98b7aa4d80fd51.svg";
export { ForwardRef as ReactComponent };